export const formSearchValues = {
    valorBusca: '',
    dtInicio: '',
    dtFim: ''
}